export const dataset = [
  {
    date: '2024-08-15',
    visits: 20,
    uploads: 15,
    downloads: 10,
  },
  {
    date: '2024-08-16',
    visits: 25,
    uploads: 12,
    downloads: 8,
  },
  {
    date: '2024-08-17',
    visits: 30,
    uploads: 14,
    downloads: 9,
  },
  {
    date: '2024-08-18',
    visits: 22,
    uploads: 10,
    downloads: 12,
  },
  {
    date: '2024-08-19',
    visits: 28,
    uploads: 9,
    downloads: 11,
  },
  {
    date: '2024-08-20',
    visits: 35,
    uploads: 16,
    downloads: 14,
  },
  {
    date: '2024-08-21',
    visits: 40,
    uploads: 17,
    downloads: 13,
  },
  {
    date: '2024-08-22',
    visits: 37,
    uploads: 14,
    downloads: 12,
  },
  {
    date: '2024-08-23',
    visits: 32,
    uploads: 15,
    downloads: 14,
  },
  {
    date: '2024-08-24',
    visits: 38,
    uploads: 18,
    downloads: 16,
  },
  {
    date: '2024-08-25',
    visits: 35,
    uploads: 19,
    downloads: 18,
  },
  {
    date: '2024-08-26',
    visits: 42,
    uploads: 17,
    downloads: 16,
  },
  {
    date: '2024-08-27',
    visits: 43,
    uploads: 18,
    downloads: 19,
  },
  {
    date: '2024-08-28',
    visits: 45,
    uploads: 21,
    downloads: 20,
  },
  {
    date: '2024-08-29',
    visits: 41,
    uploads: 19,
    downloads: 17,
  },
  {
    date: '2024-08-30',
    visits: 46,
    uploads: 20,
    downloads: 22,
  },
  {
    date: '2024-09-01',
    visits: 48,
    uploads: 22,
    downloads: 24,
  },
  {
    date: '2024-09-02',
    visits: 44,
    uploads: 19,
    downloads: 23,
  },
  {
    date: '2024-09-03',
    visits: 49,
    uploads: 24,
    downloads: 21,
  },
  {
    date: '2024-09-04',
    visits: 52,
    uploads: 25,
    downloads: 22,
  },
  {
    date: '2024-09-05',
    visits: 55,
    uploads: 26,
    downloads: 24,
  },
  {
    date: '2024-09-06',
    visits: 53,
    uploads: 22,
    downloads: 20,
  },
  {
    date: '2024-09-07',
    visits: 54,
    uploads: 27,
    downloads: 26,
  },
  {
    date: '2024-09-08',
    visits: 51,
    uploads: 23,
    downloads: 22,
  },
  {
    date: '2024-09-09',
    visits: 50,
    uploads: 21,
    downloads: 25,
  },
  {
    date: '2024-09-10',
    visits: 47,
    uploads: 20,
    downloads: 18,
  },
  {
    date: '2024-09-11',
    visits: 49,
    uploads: 24,
    downloads: 19,
  },
  {
    date: '2024-09-12',
    visits: 52,
    uploads: 25,
    downloads: 23,
  },
];

export const rankingDownload = [
  {
    name: 'Thinly-bedded sedimentary rocks',
    downloads: 56
  },
  {
    name: 'Limestone Occurrences in Johore',
    downloads: 34
  },
  {
    name: 'Upper Palaeozoic stratigraphy of the west of Kampar, Perak',
    downloads: 26
  },
  {
    name: 'On the supposed existence of the Kisap thrust in the Langkawi Islands, Northwest Peninsular Malaysia',
    downloads: 16
  },
  {
    name: 'Sandstone with Pyrite',
    downloads: 10
  },

]
  
  export function valueFormatter(value) {
    return `${value}`;
  }